import { render, staticRenderFns } from "./Anm22FileUploaderInline.vue?vue&type=template&id=5167f07d&scoped=true&"
import script from "./Anm22FileUploaderInline.vue?vue&type=script&lang=js&"
export * from "./Anm22FileUploaderInline.vue?vue&type=script&lang=js&"
import style0 from "./Anm22FileUploaderInline.vue?vue&type=style&index=0&id=5167f07d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../food/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5167f07d",
  null
  
)

export default component.exports